import React from "react";
import FormItem from "../components/items/FormItem";

const NewItemPage = () => {
  return <FormItem method="post"/>;
};

export default NewItemPage;
